import { linkPageLogin } from "routes";
import AuthService from "service/Auth.service";
import { encode } from "util/CommonUtil";

function UnAuthorized() {
  const pathWithParams = window.location.pathname + window.location.search;
  console.log(">>>>>>", pathWithParams);
  const url = pathWithParams ? `?rto=${encode(pathWithParams)}` : "";

  const onLoginClick = () => {
    AuthService.logOut();
    window.location.href = linkPageLogin + url;
  };

  return (
    <div className="fixed z-50 flex h-screen w-screen flex-col">
      <div className="flex h-9 flex-row items-center justify-center bg-primary-red-1000 text-xs text-white opacity-95 ">
        Your session has expired. Please
        <button className="mx-1 underline" onClick={onLoginClick}>
          Login
        </button>
        again
      </div>
      <div className=" w-full flex-1 bg-black/50" />
    </div>
  );
}

export default UnAuthorized;
